import './index.scss';
import {inject, observer} from 'mobx-react';
import axios from 'axios';
import {smartJump} from 'utils/utils';
import Slide from '../Slide';

@inject(({store}) => {
    const {renderData = {}} = store;
    const {economic_area_introduction, economic_area_product_tab} = renderData;
    return {
        picsData: economic_area_introduction,
        tabs: economic_area_product_tab
    };
})
@observer
class Economy extends React.Component {
    state = {
        listData: {},
        activeTabIndex: 0
    }
    tabClick = (index) => {
        const {tabs = []} = this.props;
        this.setState({
            activeTabIndex: index
        });
        if(!this.state.listData[tabs[index].id]) {
            this.getPros();
        }
    }

    componentDidMount() {
        this.getPros();
    }

    componentDidUpdate() {
        this.getPros();
    }

    getPros = () => {
        const {activeTabIndex, listData = {}} = this.state;
        const {tabs = []} = this.props;
        if(!tabs.length || this.lock) return;
        const {id} = tabs[activeTabIndex];
        if(!listData[id]) {
            this.lock = true;
            axios.get(`//oss.dujia.qunar.com/cg/detail?pos=s_dlwlj22&modules=economic_area_products &types=4&pid=${id}`)
                .then(res => res.data)
                .then(res => {
                    this.lock = false;
                    if(res.status !== 0) return;
                    const {economic_area_products = {}} = res.data;
                    listData[id] = economic_area_products[id];
                    this.setState({
                        listData
                    });
                }).catch(() => {
                    this.lock = false;
                });
        }
    }
    render() {
        const {tabs = [], picsData = {}} = this.props;
        const {activeTabIndex, listData = {}} = this.state;
        const {id, data = {}} = tabs[activeTabIndex] || {};
        const {jumpInfo: tabJumpInfo = {}, tab: tabName} = data;
        const lists = listData[id] || [];
        const {images = [], text} = picsData;
        return (
            <div className="module m-economy">
                <img className="img-bg" src={'//s.qunarzz.com/vacation_tuan/2022/dalian/economy.png'} />
                <div className="pic-text">
                    <div className="pics">
                        {
                            <Slide setting={{autoplay: true}}>
                                {
                                    images.map((item, index) => {
                                        const {banner = {}} = item;
                                        return <img className="img" key={index} src={banner.imageURL} onClick={() => {
                                            if(banner.url) {
                                                smartJump(banner.url, 'navibar-none');
                                            }
                                        }}/>;
                                    })
                                }
                            </Slide>
                        }
                    </div>
                    <div className="text">{text}</div>
                </div>
                <div className="tabs g-flexbox">
                    {
                        tabs.map((item, index) => {
                            const {data = {}} = item;
                            return (
                                <div className={`tab-item ${index === activeTabIndex ? 'active' : ''}`} key={index} data-sk-eid="tab_jingjidai" data-sk-edata={JSON.stringify({tabName: data.tab})} onClick={() => {
                                    this.tabClick(index);
                                }}>{data.tab}</div>
                            );
                        })
                    }
                </div>
                <div className="pros">
                    <div className="lists g-flexbox">
                        {
                            lists.map((item, index) => {
                                const {data = {}} = item;
                                const {product = {}, image = {}, title} = data;
                                const {jumpInfo = {}, ttsEnid} = product;
                                const {touchUrl, appUrl} = jumpInfo;
                                return (
                                    <div className="list-item" key={index} data-sk-eid="list_jingjidai" data-sk-edata={JSON.stringify({
                                        pid: ttsEnid,
                                        tabName
                                    })} onClick={() => {
                                        smartJump(hysdk.sniff.qunar ? appUrl || touchUrl : touchUrl, 'navibar-none');
                                    }}>
                                        <div className="cover">
                                            <img src={image.url || product.extensionImg || product.thumb}/>
                                        </div>
                                        <div className="cont">
                                            <div className="tit">{title || product.title}</div>
                                            <div className="btn">立即预订</div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                    {
                        tabJumpInfo.touchUrl && <div className="m-more" data-sk-eid="more_jingjidai" onClick={() => {
                            smartJump(hysdk.sniff.qunar ? tabJumpInfo.appUrl || tabJumpInfo.touchUrl : tabJumpInfo.touchUrl);
                        }}><div className="m-more-btn">查看更多</div></div>
                    }
                </div>
            </div>
        );
    }
}

export default Economy;